<template>
  <div class="text-md-left">
    <el-tabs type="card" @tab-click="tabClick">
      <el-tab-pane
        :label="item_tab"
        v-for="(item_tab,key) in TabWeightData"
        :key="key"
      >
        <div id="toggleBar">
          <el-radio-group v-model="selectToggle">
            <el-radio-button label="WeightTemplate">WEIGHT RATE TEMPLATE</el-radio-button>
            <el-radio-button :disabled="disableToggle" label="SizeTemplate">SIZE TEMPLATE</el-radio-button>
          </el-radio-group>
        </div>
        <keep-alive>
          <component :is="activeToggle" ref="toggleTemplate" />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import fgApi from '@/services/fillgoods'
import VueNumeric from 'vue-numeric'
import WeightTemplate from './WeightRateToggleTemplate/WeightTemplate'
import SizeTemplate from './WeightRateToggleTemplate/SizeTemplate'

export default {
    name: 'WeightRate',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    components: {
        VueNumeric,
        WeightTemplate,
        SizeTemplate
    },
    data () {
        return {
            TabWeightData: [],
            tabName: '',
            disableToggle: true,
            selectToggle: 'WeightTemplate',
            allData: ''
        }
    },
    provide () {
        return {
            getToggleTemplateData: () => this.allData
        }
    },
    computed: {
        activeToggle () {
            return this.selectToggle
        }
    },
    created () {
        // eslint-disable-next-line no-unused-vars
        for (let [key, value] of Object.entries(this.data.shopDetail.weightRate)) {
            this.TabWeightData.push(key)
        }
        this.tabName = this.TabWeightData[0]
        this.checkOpenSize(this.TabWeightData[0])
    },
    methods: {
        addRateWeightShop (val) {
            let objRate = {
                min: 0,
                max: 250,
                rateBkk: 0,
                rateUpc: 0
            }
            if (this.data.shopDetail.weightRate[val].length > 0) {
                objRate.min = this.data.shopDetail.weightRate[val][this.data.shopDetail.weightRate[val].length - 1].max + 0.01
                objRate.max = (objRate.min + 250) - 0.01
                objRate.rateBkk = this.data.shopDetail.weightRate[val][this.data.shopDetail.weightRate[val].length - 1].rateBkk
                objRate.rateUpc = this.data.shopDetail.weightRate[val][this.data.shopDetail.weightRate[val].length - 1].rateUpc
            }
            this.data.shopDetail.weightRate[val].push(objRate)
            this.$nextTick(() => {
                this.$refs.rate[this.$refs.rate.length - 1].$el.focus()
            })
        },
        onSetTemplate (itemTab, item, index) {
        // console.log(item)
        // console.log(this.data.shopDetail.weightRate[itemTab])
            this.$set(this.data.shopDetail.weightRate, itemTab, item)
        // console.log(itemTab, item, index)
        },
        checkOpenSize (tabName) {
            const allData = (value) => {
                this.allData = { data: this.data, tabName: this.tabName, openSize: value }
            }
            if (tabName === 'scg' || tabName === 'flash') {
                this.disableToggle = false
                allData(true)
            } else {
                this.disableToggle = true
                allData(false)
            }
        },
        tabClick (obj, e) {
            this.tabName = obj.label
            this.selectToggle = 'WeightTemplate'
            this.checkOpenSize(obj.label)
        }
    }
}
</script>
<style lang="scss" scoped>
.scroller {
  height: 100%;
}
.user {
  height: 32%;
}
#toggleBar {
  display: flex;
  justify-content: center;
}
#actionButton {
  display: flex;
  position: relative;
  margin-top: 20px;
  justify-content: space-between;
  align-items: center;
}
</style>
